import { render, staticRenderFns } from "./manage-reports-modal.vue?vue&type=template&id=35dc82dc"
import script from "./manage-reports-modal.vue?vue&type=script&lang=js"
export * from "./manage-reports-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports